import { useHistorySections } from '@src/packages/dashboard/components/ReportSummary/hooks/useHistorySections';
import type { HistorySectionState } from '@src/packages/dashboard/components/ReportSummary/hooks/useHistorySections';
import type {
  ExecutionsHistoryRouteQuery,
  ExecutionsHistoryRouteSection,
} from '@src/models/interfaces/executionsHistoryDashboard.interface';
import ExecutionsHistoryDashboardService from '@src/services/ExecutionsHistoryDashboardService';

export const ROUTE_HISTORY_SECTIONS: ExecutionsHistoryRouteSection[] = [
  'route-overview',
  'route-compliance',
  'route-events',
  'route-users',
  'route-divisions',
];

export type RouteHistorySectionState = HistorySectionState;
export type RouteSectionsState = Record<ExecutionsHistoryRouteSection, RouteHistorySectionState>;

const routeSectionQueryKey = (
  section: ExecutionsHistoryRouteSection,
  query: ExecutionsHistoryRouteQuery,
) =>
  JSON.stringify(
    section === 'route-overview'
      ? query
      : {
          organizationId: query.organizationId,
          divisionIds: query.divisionIds,
          routeIds: query.routeIds,
          range: query.range,
        },
  );

const loadRouteSection = (
  service: ExecutionsHistoryDashboardService,
  section: ExecutionsHistoryRouteSection,
  query: ExecutionsHistoryRouteQuery,
) => service.getRouteSection(section, query);

/** Loads Routes report sections independently, using the Tasks/Schedules retry contract. */
export const useRouteHistorySections = (query?: ExecutionsHistoryRouteQuery) =>
  useHistorySections<ExecutionsHistoryRouteQuery, ExecutionsHistoryRouteSection>(query, {
    sections: ROUTE_HISTORY_SECTIONS,
    queryKey: routeSectionQueryKey,
    loadSection: loadRouteSection,
  });

export type RouteHistorySectionsController = ReturnType<typeof useRouteHistorySections>;
